//@flow
import {
  USER_CAMPAIGN_GET_REQUESTING,
  USER_CAMPAIGN_SELECT,
  USER_CAMPAIGN_GET_TEAM_REQUESTING,
  SELECT_PERFECT_STEP_REQUESTING,
  ACCEPT_PERFECT_STEP_REQUESTING,
  VALIDATE_PERFECT_STEP_REQUESTING,
  SELECT_STEP,
  USER_CAMPAIGN_GET_USER_RANK_REQUESTING,
  USER_CAMPAIGN_GET_TEAM_RANK_REQUESTING,
  USER_CAMPAIGN_SET_NEXT_CATEGORY_REQUESTING,
  USER_CAMPAIGN_GET_ALL_REQUESTING,
  GET_CURRENT_USER_CAMPAIGN_REQUESTING,
  VALIDATE_PERFECT_STEP_ERROR,
  CAMPAIGN_JOIN_REQUESTING,
  GET_SPECIFIC_STEP_REQUESTING,
  SELECT_RECOMMENDED_STEPS_REQUESTING,
  GET_CAMPAIGN_REVIEWS_REQUESTING,
  UPDATE_REVIEW_REQUESTING,
  COMMENT_REVIEW_REQUESTING,
  SEE_COMMENTS_REVIEW_REQUESTING,
  CANCEL_SELECTED_STEP_REQUESTING,
  ADD_STEP_COMMENT_REQUESTING,
  REMOVE_COMMENT_REQUESTING,
  UPDATE_COMMENT_REQUESTING,
  GET_STEP_COMMENT_REQUESTING,
  GET_STEP_COMMENT_INFO_REQUESTING,
  GET_ALL_RESPONSES_REQUESTING,
  ADD_LIKE_STEP_COMMENT_REQUESTING,
  REMOVE_LIKE_STEP_COMMENT_REQUESTING,
  SEND_RESPONSE_REQUESTING,
  GET_EVENTS_REQUESTING,
  SELECT_FEEDBACK_ID,
  SELECT_FEEDBACK_FROM_STEP_ID,
} from "./constants";

import { IReviewCommentType } from "./types";

export const getCurrentUserCampaignRequest = (payload: { userId: string }) => {
  return {
    type: GET_CURRENT_USER_CAMPAIGN_REQUESTING,
    payload,
  };
};

export const getUserCampaignRequest = (payload: { userCampaignId: string }) => {
  return {
    type: USER_CAMPAIGN_GET_REQUESTING,
    payload,
  };
};

export const getAllUserCampaignRequest = (payload: { userId: string }) => {
  return {
    type: USER_CAMPAIGN_GET_ALL_REQUESTING,
    payload,
  };
};

// récupère les userCampaign du userCampaigns, mais je sais pas se qu'il y a dedans
export const selectCampaign = (payload: {}) => {
  return {
    type: USER_CAMPAIGN_SELECT,
    payload,
  };
};

export const getTeamRequest = (payload: {
  campaignId: string;
  userId: string;
}) => {
  return {
    type: USER_CAMPAIGN_GET_TEAM_REQUESTING,
    payload,
  };
};

export const getEventsRequest = (payload: { campaignId: string }) => {
  return {
    type: GET_EVENTS_REQUESTING,
    payload,
  };
};

// utilisé ?
export const selectPerfectStepRequest = (payload: {
  userCampaignId: string;
  userId: string;
  trackId: string;
}) => {
  return {
    type: SELECT_PERFECT_STEP_REQUESTING,
    payload,
  };
};

export const selectRecommendedStepRequest = (payload: {
  userCampaignId: string;
  userId: string;
  trackId: string;
  hasRequestedForNewActions?: Date | string | undefined;
}) => {
  return {
    type: SELECT_RECOMMENDED_STEPS_REQUESTING,
    payload,
  };
};

export const acceptPerfectStepRequest = (payload: {
  userCampaignId: string;
  stepId: string;
}) => {
  return {
    type: ACCEPT_PERFECT_STEP_REQUESTING,
    payload,
  };
};

// ne recoit rien lors de l'appel et le saga n'utilise rien de l'action
export const validatePerfectStepRequest = () => {
  return {
    type: VALIDATE_PERFECT_STEP_REQUESTING,
  };
};

// il faudrait savoir se que stepSelected contient, je n'ai pas trouvé
export const selectStep = (payload: {
  stepSelectedIndex?: number;
  stepSelected: {};
}) => {
  return {
    type: SELECT_STEP,
    payload,
  };
};

// utilisé ?
export const getUserRankRequest = (payload: {
  userCampaignId: String;
  campaignId: String;
}) => {
  return {
    type: USER_CAMPAIGN_GET_USER_RANK_REQUESTING,
    payload,
  };
};

export const getTeamRankRequest = (payload: {
  userId: String;
  campaignId: String;
}) => {
  return {
    type: USER_CAMPAIGN_GET_TEAM_RANK_REQUESTING,
    payload,
  };
};

export const setNextCategoryRequest = (payload: {
  nextCategory: String;
  userCampaignId: String;
}) => {
  return {
    type: USER_CAMPAIGN_SET_NEXT_CATEGORY_REQUESTING,
    payload,
  };
};

// bizarre le payload vide pour set le message d'erreur
export const removeError = () => {
  return {
    type: VALIDATE_PERFECT_STEP_ERROR,
    payload: "",
  };
};

export const addParticipantsRequest = (payload: {
  newParticipants: string[];
  accessCode: string;
  userId: string;
  campaignId: string; // il n'est pas envoyé lors de l'appel de la fonction mais est utilisé dans le controller addParticipants de campaign
}) => {
  return {
    type: CAMPAIGN_JOIN_REQUESTING,
    payload,
  };
};

export const getSpecificStepRequest = (stepId: string) => {
  return {
    type: GET_SPECIFIC_STEP_REQUESTING,
    payload: stepId,
  };
};

export const getReviewsRequest = () => {
  return {
    type: GET_CAMPAIGN_REVIEWS_REQUESTING,
  };
};

export const updateReviewRequest = (payload: {
  stepFeedbackId: string;
  fileComment: IReviewCommentType;
}) => {
  return {
    type: UPDATE_REVIEW_REQUESTING,
    payload,
  };
};

export const commentReviewRequest = (payload: {
  stepFeedbackId: string;
  comment: IReviewCommentType;
  coachId: string;
  userId: string;
}) => {
  return {
    type: COMMENT_REVIEW_REQUESTING,
    payload,
  };
};

export const seeCommentsReviewRequest = (payload: {
  stepFeedbackId: string;
}) => {
  return {
    type: SEE_COMMENTS_REVIEW_REQUESTING,
    payload,
  };
};

export const selectReviewFromFeedbackId = (stepFeedbackId: string) => {
  return {
    type: SELECT_FEEDBACK_ID,
    payload: stepFeedbackId,
  };
};

export const selectReviewFromStepId = (stepId: string) => {
  return {
    type: SELECT_FEEDBACK_FROM_STEP_ID,
    payload: stepId,
  };
};

export const cancelSelectedStepRequest = (payload: {
  hasRequestedForUnblock?: boolean;
  comment?: string;
  reason?: string;
  isDoItLaterOptionChecked?: boolean;
}) => {
  return {
    type: CANCEL_SELECTED_STEP_REQUESTING,
    payload,
  };
};

export const addStepCommentRequest = (payload: {
  stepId: string;
  comment: string;
  fileId: string;
  campaignId: string;
}) => {
  return {
    type: ADD_STEP_COMMENT_REQUESTING,
    payload,
  };
};

export const removeStepCommentRequest = (payload: {
  stepCommentId: string;
}) => {
  return {
    type: REMOVE_COMMENT_REQUESTING,
    payload,
  };
};

export const updateStepCommentRequest = (payload: {
  stepCommentId: string;
  comment: string;
}) => {
  return {
    type: UPDATE_COMMENT_REQUESTING,
    payload,
  };
};

export const getStepCommentsByStepId = (payload: { stepId: string }) => {
  return {
    type: GET_STEP_COMMENT_REQUESTING,
    payload,
  };
};

export const getStepCommentInfoByStepId = (payload: { stepId: string }) => {
  return {
    type: GET_STEP_COMMENT_INFO_REQUESTING,
    payload,
  };
};

export const getAllResponsesByStepCommentId = (payload: {
  stepCommentId: string;
}) => {
  return {
    type: GET_ALL_RESPONSES_REQUESTING,
    payload,
  };
};

export const addLikeToCommentary = (payload: {
  stepCommentId: string;
  userId: string;
}) => {
  return {
    type: ADD_LIKE_STEP_COMMENT_REQUESTING,
    payload,
  };
};

export const removeLikeFromCommentary = (payload: {
  stepCommentId: string;
  userId: string;
}) => {
  return {
    type: REMOVE_LIKE_STEP_COMMENT_REQUESTING,
    payload,
  };
};

export const sendResponseToStepComment = (payload: {
  stepCommentId: string;
  receiverId: string;
  comment: string;
  stepId: string;
  campaignId: string;
}) => {
  return {
    type: SEND_RESPONSE_REQUESTING,
    payload,
  };
};
